import React from "react";
import FaseContainer from "../../containers/structure/FaseContainer";
import { languages } from "../../constants/languages";
import EditFaseContainer from "../../containers/structure/EditFaseContainer";
import Typography from "@material-ui/core/Typography";

const StructureFases = (props) => (
  <div
    style={{
      whiteSpace: "nowrap",
      overflowX: "scroll",
      display: "flex",
      alignItems: "flex-start",
    }}
  >
    {props.division.fases ? (
      props.division.fases.map((fase, i) => (
        <FaseContainer
          key={i}
          tournament={props.tournament}
          divisionsObject={props.divisionsObject}
          division={props.division}
          teams={props.teams}
          teamsNotDivided={props.teamsNotDivided}
          resultSpotsNotDivided={props.resultSpotsNotDivided}
          resultSpotsAll={props.resultSpotsAll}
          poules={props.poules.filter((poule) => poule.fase === i)}
          fase={i}
          faseObject={fase}
          faseStarted={fase.started}
          poulesByKey={props.poulesByKey}
          allBracketsForPhase={props.allBrackets.filter(
            (bracket) => bracket.fase === i
          )}
          brackets={props.brackets.filter((bracket) => bracket.fase === i)}
          subBrackets={props.subBrackets}
          bracketsByKey={props.bracketsByKey}
          numDivided={props.numDivided}
          maxTeams={props.maxTeams}
          user={props.user}
          userStatus={props.userStatus}
          tournamentStatus={props.tournamentStatus}
          toggleFinishedDialog={props.toggleFinishedDialog}
          userData={props.userData}
          daysByKey={props.daysByKey}
          toggleUpgradeDialog={props.toggleUpgradeDialog}
        />
      ))
    ) : (
      <FaseContainer
        tournament={props.tournament}
        divisionsObject={props.divisionsObject}
        division={props.division}
        teams={props.teams}
        teamsNotDivided={props.teamsNotDivided}
        resultSpotsNotDivided={[]}
        resultSpotsAll={props.resultSpotsAll}
        poules={props.poules.filter((poule) => poule.fase === 0)}
        fase={0}
        faseObject={{ name: languages.structure.fase + " 1", started: true }}
        faseStarted={true}
        poulesByKey={props.poulesByKey}
        allBracketsForPhase={props.allBrackets.filter(
          (bracket) => bracket.fase === 0
        )}
        brackets={props.brackets.filter((bracket) => bracket.fase === 0)}
        subBrackets={props.subBrackets}
        bracketsByKey={props.bracketsByKey}
        numDivided={props.numDivided}
        maxTeams={props.maxTeams}
        user={props.user}
        userStatus={props.userStatus}
        tournamentStatus={props.tournamentStatus}
        toggleFinishedDialog={props.toggleFinishedDialog}
        userData={props.userData}
        daysByKey={props.daysByKey}
        toggleUpgradeDialog={props.toggleUpgradeDialog}
      />
    )}
    <div style={{ width: 220, paddingTop: 18 }}>
      <div style={{ paddingBottom: 10 }}>
        <EditFaseContainer
          tournament={props.tournament}
          division={props.division}
          tournamentStatus={props.tournamentStatus}
          toggleFinishedDialog={props.toggleFinishedDialog}
        />
      </div>
      <Typography
        variant="caption"
        style={{ whiteSpace: "normal", width: 220 }}
      >
        {languages.formatString(
          languages.structure.addFaseDescription,
          props.tournament.individualPlayers
            ? languages.teams.playersLow
            : languages.tournament.teamsLow
        )}
      </Typography>
    </div>
  </div>
);

export default StructureFases;
